module.exports = __webpack_public_path__ + "static/img/index_aboutus_1.2ea255e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index_aboutus_1.png
// module id = WC8H
// module chunks = 0